/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoSbpIcon16Solid = forwardRef('LogoSbpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.501.61A1 1 0 0 1 8.5.607l5.481 3.132a1 1 0 0 1-.002 1.737L9.537 8l4.441 2.524a1 1 0 0 1 .002 1.737L8.5 15.393a1 1 0 0 1-1.497-.868V9.44L2.494 12A1 1 0 0 1 1 11.132V4.868a1 1 0 0 1 1.494-.87L7.003 6.56V1.475A1 1 0 0 1 7.501.61ZM5.488 8 3 6.586v2.828L5.488 8Zm3.515 1.997 2.461 1.399-2.461 1.406V9.997Zm0-3.994V3.198l2.461 1.406-2.461 1.399Z" })));
});
